/* util/saker-url.js — schemavalidering för länkar byggda ur tredjepartsdata.
 *
 * `esc()`/`escapeHtml()` HTML-escapar, men stoppar INTE `javascript:` — en
 * `website=javascript:...` i OSM blir en klickbar XSS i popupen så fort URL:en
 * går rakt in i ett `href`. Datat i overlay-lagren kommer från OSM (användar-
 * bidraget), Wikimedia Commons och myndighets-GeoPackages; inget av det är
 * teckenkontrollerat av oss.
 *
 * Regeln: bara http/https släpps igenom. OSM skriver ofta "example.se" utan
 * schema — då antas https, aldrig något annat. Allt annat (javascript:, data:,
 * vbscript:, skräp som inte parsar) blir null och länken renderas inte alls.
 *
 * Använd ALLTID tillsammans med esc():  href="${esc(sakerUrl(p.website))}"
 * — sakerUrl äger schemat, esc äger HTML-attributkontexten.
 *
 * state/osm-detaljer.js hade en egen kopia fram till mergen 2026-08-04 och
 * importerar härifrån sedan dess. Fälla #378.
 */

export function sakerUrl(rå) {
    const s = String(rå || '').trim();
    if (!s) return null;

    // Relativ referens till vår EGEN origin ("/kommun/0180", "?lan=X", "#tack").
    // Den kan omöjligt bära ett schema och är därför alltid säker. Utan den här
    // grenen blir "/kommun/0180" till "https://kommun/0180" — en trasig extern
    // länk, tyst. Gäller anropare som blandar interna och externa URL:er
    // (quiz-result.js:s annonskort, listCard-slotten i kommun.js).
    // "//host/x" är däremot PROTOKOLL-relativ, alltså extern, och valideras.
    if (/^[/?#]/.test(s) && !s.startsWith('//')) return s;

    const kandidat = s.startsWith('//') ? 'https:' + s
        : /^[a-z][a-z0-9+.-]*:/i.test(s) ? s
            : 'https://' + s;
    try {
        const u = new URL(kandidat);
        return (u.protocol === 'http:' || u.protocol === 'https:') ? u.href : null;
    } catch (e) {
        return null;
    }
}
